
// src/components/AliUpload/upload.js

var __awaiter =
    (this && this.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                    resolve(value);
                });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
import React, { useEffect, useRef } from 'react';
import { App, Upload } from 'antd';
import { createClientService } from "@/lib/http/client";
import Image from 'next/image';

const AliyunOSSUpload = ({ value = [], onChange, max = 1, picDir, bucket = 'public-read-bkt-oss', multiple = true }) => {
    const { message } = App.useApp();

    const OSSDataRef = useRef(); // 新增 ref 用于同步最新凭证

    const isRefreshing = useRef(false);
    const uploadQueue = useRef([]); // 等待上传的文件队列

    const bucketDomain = 'https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/';
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield createClientService().get(
                'mtop.oss.getH5PolicySign',
                { data: { dir: picDir, bucket } },
                { cache: false }
            );
            // setOSSData(result);
            OSSDataRef.current = result; // 同步到 ref
            return result; // 返回结果供调用方使用
        } catch (err) {
            if (err instanceof Error) message.error(err.message);
            throw err; // 抛出错误以便上层处理
        }
    });



    // useEffect(() => {
    //     init();
    // }, []);

    const checkAndRefreshToken = (file) => __awaiter(void 0, void 0, void 0, function* () {
        if (!OSSDataRef.current) return yield init();

        const expire = Number(OSSDataRef.current.expire) * 1000;
        const isTokenValid = expire > Date.now();

        if (isTokenValid) {
            return OSSDataRef.current;
        }

        // 如果已经在刷新，加入队列等待
        if (isRefreshing.current) {
            return new Promise(resolve => {
                uploadQueue.current.push({ file, resolve });
            });
        }

        try {
            // 标记刷新状态
            isRefreshing.current = true;
            console.log("凭证过期，重新获取...");
            const newToken = yield init();

            // 处理队列中的所有文件
            while (uploadQueue.current.length > 0) {
                const { file: queuedFile, resolve } = uploadQueue.current.shift();
                const suffix = queuedFile.name.slice(queuedFile.name.lastIndexOf('.'));
                const uniqueId = Math.random().toString(36).slice(2, 10);
                const filename = `${Date.now()}_${uniqueId}${suffix}`;

                queuedFile.key = `${newToken.dir}${filename}`;
                queuedFile.url = `${bucketDomain}${newToken.dir}${filename}`;
                resolve(queuedFile);
            }

            return newToken;
        } finally {
            isRefreshing.current = false;
        }
    });



    const beforeUpload = (file) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const currentOSS = yield checkAndRefreshToken(file); // 确保凭证最新

            // 如果文件已在队列中处理过，直接返回
            if (file.url) return file;

            // 生成文件名
            const suffix = file.name.slice(file.name.lastIndexOf('.'));
            const uniqueId = Math.random().toString(36).slice(2, 10); // 8位随机字符串
            const filename = `${Date.now()}_${uniqueId}${suffix}`; // 添加随机标识符
            file.key = currentOSS.dir + filename;
            file.url = bucketDomain + currentOSS.dir + filename;

            return file;
        } catch (err) {
            message.error("上传准备失败：" + err.message);
            return false;
        }
    });

    // 使用 ref 获取实时凭证（关键修改）
    const getExtraData = (file) => {
        const current = OSSDataRef.current;
        return {
            key: file.key,
            OSSAccessKeyId: current?.accessid,
            policy: current?.policy,
            Signature: current?.signature
        };
    };

    const handleChange = ({ fileList }) => {
        // console.log('Aliyun OSS:', fileList);
        onChange?.([...fileList]);
    };

    const onRemove = (file) => {
        const files = (value || []).filter(v => v.url !== file.url);
        onChange?.(files);
    };

    const uploadProps = {
        name: 'file',
        fileList: value,
        maxCount: max,
        action: bucketDomain, // 使用 ref 的值
        onChange: handleChange,
        onRemove,
        multiple,
        data: getExtraData,
        beforeUpload,
    };
    return (
        <Upload {...uploadProps} listType="picture-card">
            {value.length < max && <Image src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/icon_uploder_i.png" alt="uploader" width={50} height={39} />}
        </Upload>
    );
};

export default AliyunOSSUpload;